<style lang="less">
@import '../../../../stylesheet/variable.less';

.pay-view {
  min-height: 100vh;
  background: white;
  .pay-box {
    position: relative;
    top: 44px;
    left: 0;
    right: 0;
    min-height: calc(100vh - 44px);
    background: #fff;
  }
  .pay-callback-view {
    margin-bottom: 10px;
    font-size: 15px;
    background: #fff;
    height: 308px;
    text-align: center;
    padding-top: 55px;
    .groupon-callback-msg {
      margin-bottom: 8px;
      span {
        color: rgb(255, 95, 22);
      }
    }
    .pay-callback-view-img {
      width: 40px;
      height: 40px;
      vertical-align: middle;
    }
    .pay-status-text {
      line-height: 15px;
      margin-top: 20px;
      margin-bottom: 8px;
      color: #191a1b;
    }
    .callback-msg {
      color: rgb(189, 192, 197);
      font-size: 13px;
      &.card-delay {
        color: rgb(121, 125, 130);
      }
    }
    .card-delay-info {
      width: 200px;
      margin: 15px auto 0;
      position: relative;
      padding: 15px 6px 0;
      font-size: 13px;
      line-height: 18px;
      color: rgb(121, 125, 130);
      .carnum {
        display: flex;
        justify-content: space-between;
        margin-bottom: 3px;
        span:last-child {
          width: 50%;
          color: #191a1b;
          text-align: left;
          position: relative;
          right: -16px;
          display: inline-block;
        }
      }
      .enddate {
        display: flex;
        justify-content: space-between;
        span:last-child {
          width: 50%;
          color: rgb(255, 95, 22);
          text-align: left;
          position: relative;
          right: -16px;
          display: inline-block;
        }
      }
      // &::after {
      //   .setTopLine(rgb(237, 237, 237));
      // }
    }
    .order-goods {
      min-height: 115px;
      padding: 15px;
      background: #fff;
      border-bottom: 1px solid rgb(237, 237, 237);
      .sku-img {
        width: 85px;
        height: 85px;
        float: left;
        margin-right: 15px;
        img {
          width: 85px;
        }
      }
      .sku-prduct-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .sku-name {
        font-size: 13px;
        margin-bottom: 15px;
      }
      .price-level {
        float: left;
        margin-bottom: 0;
      }
    }
    .major-btn {
      background: rgb(255, 95, 22);
      color: #fff;
      font-size: 15px;
      text-align: center;
      width: 300px;
      height: 44px;
      line-height: 44px;
      margin: 50px auto 20px;
      position: relative;
      border-radius: 2px;
    }
    .minor-btn {
      font-size: 13px;
      color: rgb(121, 125, 130);
    }
    .groupon-btn {
      margin-top: 30px;
    }
    .to-detail-btn {
      color: rgb(255, 95, 22);
      font-size: 13px;
      text-align: center;
      width: 150px;
      height: 33px;
      line-height: 33px;
      margin: 50px auto 17px;
      position: relative;
      &:after {
        .setBorderLine();
        border-color: rgb(255, 95, 22);
        border-radius: 2px;
      }
    }
    .groupon-to-detail-btn {
      height: 33px;
      line-height: 33px;
      margin: 30px auto 20px;
    }
    &.card-delay-order {
      .action-btn {
        display: flex;
        margin: 30px 50px 20px 50px;
        justify-content: center;
        .to-detail-btn {
          margin: 0;
          width: 120px;
          position: relative;
          margin-left: 30px;

          &:after {
            .setBorderLine();
            border-color: rgb(255, 95, 22);
            border-radius: 2px;
          }
        }
        .back-home {
          color: #191a1b;
          font-size: 13px;
          text-align: center;
          width: 120px;
          height: 33px;
          line-height: 33px;
          position: relative;

          &:after {
            .setBorderLine();
            border-color: #191a1b;
            border-radius: 2px;
          }
        }
      }
    }
  }
  .groupon-order-view {
    height: 397px;
  }
  .groupon-order-complete-view {
    height: 386px;
  }
  .img {
    animation: circle 1s infinite linear;
    -webkit-animation: circle 1s infinite linear;
  }
  @keyframes circle {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
.mint-msgbox-message {
  line-height: 22.5px;
  text-align: left;
}
</style>

<template>
  <div class="pay-view" v-track="{ act: 'ready', data: { id: 386 } }">
    <myHeader></myHeader>
    <div class="pay-box" v-show="!isLoading">
      <div v-show="!payError">
        <div v-if="isCardDelayOrder" class="pay-callback-view card-delay-order">
          <img class="pay-callback-view-img" :src="statusImg" :class="{ img: outTime }" />
          <div class="pay-status-text">{{ payStatusText }}</div>
          <div class="pay-callback-msg callback-msg card-delay">{{ payCallbackMsg }}</div>
          <div class="card-delay-info">
            <div class="carnum">
              <span>卖座券</span>
              <span>{{ cardNum | cardNum }}</span>
            </div>
            <div class="enddate">
              <span>有效期已延至</span>
              <span>{{ endDate }}</span>
            </div>
          </div>

          <div class="action-btn">
            <div class="back-home" @click.prevent="toOrderDetail">查看订单</div>
            <div class="to-detail-btn" @click="toHome">立即使用</div>
          </div>
        </div>
        <div v-else :class="`pay-callback-view ${isGrouponOrder ? 'groupon-order-view' : ''} ${isGouponComplete ? 'groupon-order-complete-view' : ''}`">
          <img class="pay-callback-view-img" :src="statusImg" :class="{ img: outTime }" />
          <div class="pay-status-text">{{ payStatusText }}</div>
          <div class="pay-callback-msg callback-msg" v-if="!isGrouponOrder">{{ payCallbackMsg }}</div>
          <div class="groupon-callback-msg callback-msg" v-if="isNeedShare">
            还差
            <span>{{ groupStillNeedNum }}</span
            >人，拼单成功才能发货哦
          </div>
          <div class="groupon-callback-msg callback-msg" v-if="isGouponComplete">拼单成功，预计{{ maxDeliveryDate }}个工作日发货</div>
          <uugroupon-attendee :member="groupMembers" v-if="isGrouponOrder"></uugroupon-attendee>
          <div v-if="isNeedShare">
            <div class="major-btn groupon-btn" @click="invitFriends">
              <!-- <div class="major-btn groupon-btn" @click="invitFriends" v-track="{act:'click',data:{id:140,p:[orderId,groupCode]}}"> -->
              邀请好友拼单{{ reGroupExpireTime }}
            </div>
            <div class="minor-btn" @click.prevent="toOrderDetail">订单详情</div>
            <share-indicator :isshow="showShareIndicator" @on-touchmove="disableShareIndicator"></share-indicator>
          </div>
          <div v-else>
            <div class="to-detail-btn groupon-to-detail-btn" v-if="orderType == 4" @click.prevent="toOrderDetail">订单详情</div>
            <div class="to-detail-btn" v-if="orderType != 4" @click.prevent="toOrderDetail">订单详情</div>
            <div class="back-home minor-btn" @click="toHome">返回首页</div>
          </div>
        </div>
        <div style="background-color: white;padding:10px;" v-if="this.$store.state.preorder.billboardList.length > 0">
          <div style="text-align:center;margin-bottom: 10px;">- 推荐 -</div>
          <billboards />
        </div>
        <!-- <Recommend></Recommend> -->
      </div>
      <Noneorder :text="errorText" :imgUrl="errorImg" v-show="payError" class="no-order"></Noneorder>
    </div>
    <loading text="支付中..." v-show="isLoading"></loading>
  </div>
</template>
<script>
import billboards from '../../film/list/sub_view/result_billboards.vue'
import _ from 'underscore'
import op from 'object-path'
import { MessageBox, Toast } from 'mint-ui'
import moment from 'moment'
import { mapState, mapActions, mapGetters } from 'vuex'
import { isLogged, toLogin, getPayTypeText, generateShareLink, priceConversion, addWaterMark, sessionStore } from '../../../util/function'
import HOMECONSTANT from '../../../constant/home.js'
import ORDERCONSTANT from '../../../constant/order'
import PAYCONSTANT from '../../../constant/pay'
import COOKIE_CONSTANT from '../../../constant/cookie'
import Recommend from './sub_view/recommend'
import Noneorder from '../../../components/default-page'
import myHeader from '../../../components/header'
import ShareIndicator from '../../../components/share-indicator'
import cookie from '../../../lib/cookie'
import PREORDER_CONSTANT from '../../../constant/preorder'
import ORDER_CONSTANT from '../../../constant/order'
import ACTIVITY_CONSTANT from '../../../constant/activity'
import uugrouponAttendee from '../../../components/uugroup-attendee'
import Loading from '../../../components/loading.vue'
import sharetofriend from '../../../util/sharetofriend'
import { app } from '../../../util/platform'
import { activeRestTime, secondCountDown } from './func'
import { trackData } from '../../../directives/track.js'

const ID_TYPE_ORDERID = 1
const ID_TYPE_PAY_ORDERID = 2
export default {
  data() {
    return {
      showShareIndicator: false,
      outTime: false,
      timer: 0,
      time: 0,
      isLoading: true,
      payStatus: null,
      payError: false,
      errorText: '',
      errorImg: '',
      payOrderId: this.$route.params.id,
      orderId: '',
      payType: this.$route.params.payType,
      orderType: +this.$route.query.orderType, //订单类型
      productName: '卖座电影商品',
      groupCode: '', // 拼团id
      maxDeliveryDate: 3, //最大发货期限
      groupMembers: [], //拼团成员
      groupStillNeedNum: 0, //已拼人数
      groupExpireTime: 0, //拼团有效结束时间
      groupTimer: 0,
      now: +moment(),
      groupStatus: '',
      shareData: {
        title: '',
        desc: '',
        imgUrl: '',
      },

      loadingImg: require('../../../../image/item/group2.png'),
      noneImg: require('../../../../image/order/rectangle@2x.png'),
      systemImg: require('../../../../image/order/rectangleCopy19@2x.png'),
      cardNum: '',
      endDate: '',
    }
  },
  components: {
    Recommend,
    Noneorder,
    myHeader,
    billboards,
    Loading,
    ShareIndicator,
    uugrouponAttendee,
  },
  computed: {
    ...mapGetters(['cityGetSelectedCity']),
    selected() {
      return this.cityGetSelectedCity
    },
    payTypeText: context => {
      return getPayTypeText(context.payType)
    },
    payStatusText: context => {
      const payStatus = context.payStatus
      switch (payStatus) {
        case 0:
          if (context.isCardDelayOrder) {
            return '延期成功'
          }
          return '支付成功'
        case -1:
          return `支付失败`
        case 6803001:
          return '订单不存在'
        case 6803006:
          if (context.time > 6) {
            return '支付信息加载失败，请查看订单详情'
          }
          return '支付中...'
        default:
          return '等待支付'
      }
    },
    statusImg: context => {
      if (context.payStatus != 6803006) {
        return require('../../../../image/order/group6@2x.png')
      }
      if (context.payStatus == 6803006) {
        if (context.time > 5) {
          return require('../../../../image/order/group6@2x.png')
        } else {
          return require('../../../../image/item/group2.png')
        }
      }
    },
    payCallbackMsg: context => {
      let productType = op(context.$route.query).get('productType')
      if (context.$route.name === 'eCNYPayCallback') {
        productType = PREORDER_CONSTANT.PREORDER_PRODUCT_TYPE_FILM_TICKET
      }

      if (context.payStatus == 0) {
        if (context.isCardDelayOrder) {
          return ''
        }
        switch (productType) {
          case '1':
          case '2':
            return '预计1-15分钟出票成功'
          case '3':
          case '4':
          case '5':
            return '预计1-15分钟内充值到账'
          case PREORDER_CONSTANT.PREORDER_PRODUCT_TYPE_DELAY + '':
            return ''
          default:
            return '你的包裹正在整装待发'
        }
      }
      if (context.payStatus == -1) {
        return `未能成功扣除${context.payTypeText}账户资金，请重新购买`
      }
    },
    isGrouponOrder: context => {
      if (context.orderType === PREORDER_CONSTANT.PREORDER_ORDER_TYPE_GROUPON) {
        return true
      }
      return false
    },
    isNeedShare: context => {
      if (context.isGrouponOrder && context.groupStatus === ACTIVITY_CONSTANT.ACTIVITY_UUG_GROUP_STATUS_IS_PENDING && context.groupStillNeedNum > 0) {
        return true
      }
      return false
    },
    isGouponComplete: context => {
      if (context.isGrouponOrder && context.groupStatus === ACTIVITY_CONSTANT.ACTIVITY_UUG_GROUP_STATUS_IS_OK) {
        return true
      }
      return false
    },
    reGroupExpireTime() {
      let ret = secondCountDown(this.groupExpireTime, this.now)
      if (ret == '已结束') {
        return ''
      }
      return `（${ret}）`
    },
    isCardDelayOrder: context => {
      return context.orderType == PREORDER_CONSTANT.PREORDER_ORDER_TYPE_CARDDELAY
    },
  },
  mounted() {
    this.getResultBanners(this.selected.cityId).catch(e => {
      Toast({
        message: e,
        position: 'bottom',
        duration: 3000,
      })
    })
    // 判断登录
    if (!isLogged()) {
      MessageBox.alert('请先登录').then(action => {
        toLogin()
      })
      return
    }
    console.log('this.$route', this.$route)

    if (this.$route.name === 'eCNYPayCallback') {
      this.payOrderId = this.$route.query.ORDERID
      this.payType = PREORDER_CONSTANT.PREORDER_PAY_DIGITALIZE_CNY
      this.orderType = PREORDER_CONSTANT.PREORDER_PRODUCT_TYPE_FILM_TICKET
      this.productType = PREORDER_CONSTANT.PREORDER_PRODUCT_TYPE_FILM_TICKET
    }

    if (this.payType == 0) {
      this.payStatus = 0
      this.isLoading = false
      return
    }

    this.time++
    this.getPayStatus()

    this.fetchPayStatus()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  watch: {
    time(newVal, oldVal) {
      if (newVal > 6) {
        clearInterval(this.timer)
        this.timer = 0
        this.isLoading = false
      }
    },
    async payStatus(newVal, oldVal) {
      const vm = this
      if (newVal == 0) {
        // TODO: 暂时去掉现金券
        // this.getCouponInfo()
        if (this.isGrouponOrder) {
          await this.getOrderDetail()
          await this.getGrouponMembers()
          // 默认设置分享
          setTimeout(() => {
            sharetofriend(
              {
                ...this.shareData,
                link: generateShareLink({
                  ...this.shareData.link,
                  eventId: 149,
                }),
                success: function() {
                  // 数据埋点
                  let payOrderId = vm.payOrderId
                  let groupCode = vm.groupCode
                  let shareIdentifier = sessionStore.get('shareIdentifier')
                  let pShareIdentifier = sessionStore.get('pShareIdentifier')
                  let shareCount = sessionStore.get('shareCount')
                  // trackData({id: 149, p: [payOrderId, groupCode, shareIdentifier, pShareIdentifier, shareCount]})
                },
              },
              {
                ...this.shareData,
                link: generateShareLink({
                  ...this.shareData.link,
                  eventId: 150,
                }),
                success: function() {
                  // 数据埋点
                  let payOrderId = vm.payOrderId
                  let groupCode = vm.groupCode
                  let shareIdentifier = sessionStore.get('shareIdentifier')
                  let pShareIdentifier = sessionStore.get('pShareIdentifier')
                  let shareCount = sessionStore.get('shareCount')
                  // trackData({id: 150, p: [payOrderId, groupCode, shareIdentifier, pShareIdentifier, shareCount]})
                },
              },
            )
          }, 200)
        } else if (this.isCardDelayOrder) {
          this.$store
            .dispatch('getOrderSimple', {
              payOrderId: this.payOrderId,
            })
            .then(data => {
              this.orderId = op(data).get('orderId.0')
              this.cardNum = op(data).get('cardPostponeInfo.cardNum')
              this.endDate = moment.unix(op(data).get('cardPostponeInfo.newPeriod')).format('YYYY-MM-DD')
            })
        }
      }
    },
  },
  methods: {
    ...mapActions(['getResultBanners']),
    disableShareIndicator() {
      this.showShareIndicator = false
    },
    toHome() {
      this.$router.push({ name: 'home' })
    },
    fetchPayStatus() {
      this.timer = setInterval(() => {
        this.time++
        this.getPayStatus()
      }, 5000)
    },
    invitFriends() {
      const vm = this
      if (!app.isWechat()) {
        return Toast({
          message: '仅在微信中打开才支持分享哟~',
          position: 'bottom',
        })
      }
      this.showShareIndicator = true
      sharetofriend(
        {
          ...this.shareData,
          link: generateShareLink({ ...this.shareData.link, eventId: 149 }),
          success: function() {
            // 数据埋点
            let payOrderId = vm.payOrderId
            let groupCode = vm.groupCode
            let shareIdentifier = sessionStore.get('shareIdentifier')
            let pShareIdentifier = sessionStore.get('pShareIdentifier')
            let shareCount = sessionStore.get('shareCount')
            // trackData({id: 149, p: [payOrderId, groupCode, shareIdentifier, pShareIdentifier, shareCount]})
          },
        },
        {
          ...this.shareData,
          link: generateShareLink({ ...this.shareData.link, eventId: 150 }),
          success: function() {
            // 数据埋点
            let payOrderId = vm.payOrderId
            let groupCode = vm.groupCode
            let shareIdentifier = sessionStore.get('shareIdentifier')
            let pShareIdentifier = sessionStore.get('pShareIdentifier')
            let shareCount = sessionStore.get('shareCount')
            // trackData({id: 150, p: [payOrderId, groupCode, shareIdentifier, pShareIdentifier, shareCount]})
          },
        },
      )
      Toast({
        message: '点击右上角进行分享',
        position: 'bottom',
      })
    },
    getPayStatus() {
      this.$store
        .dispatch('getPayStatus', {
          payType: this.payType,
          payOrderId: this.payOrderId,
        })
        .then(res => {
          this.payStatus = res.status
          if (res.status == 0) {
            clearInterval(this.timer)
            this.timer = 0
            this.isLoading = false
          } else if (res.status == 6803006) {
            // 未查询到支付状态
            return
          } else {
            clearInterval(this.timer)
            this.timer = 0
            this.isLoading = false
            this.payError = true
            this.errorImg = this.systemImg
            this.errorText = res.msg
          }
        })
    },
    toOrderDetail() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.orderType == PREORDER_CONSTANT.PREORDER_PRODUCT_TYPE_FILM_TICKET) {
        let type = this.payStatus === 0 ? ID_TYPE_ORDERID : ID_TYPE_PAY_ORDERID
        let id = this.payOrderId
        return this.$router.push({
          name: 'userOrderDetail',
          params: {
            id: id,
          },
          query: {
            type: type,
          },
        })
      }
      if (this.orderType == PREORDER_CONSTANT.PREORDER_ORDER_TYPE_GROUPON) {
        let type = this.payStatus === 0 ? ID_TYPE_ORDERID : ID_TYPE_PAY_ORDERID
        let id = this.payStatus === 0 ? this.orderId : this.payOrderId
        return this.$router.push({
          name: 'userOrderDetail',
          params: {
            id: id,
          },
          query: {
            type: type,
          },
        })
      }
      if (this.orderType == PREORDER_CONSTANT.PREORDER_ORDER_TYPE_CARDDELAY) {
        let type = this.payStatus === 0 ? ID_TYPE_ORDERID : ID_TYPE_PAY_ORDERID
        let id = this.payStatus === 0 ? this.orderId : this.payOrderId
        // console.log('type:', type)
        // console.log('id:', id)
        return this.$router.push({
          name: 'userOrderDetail',
          params: {
            id: id,
          },
          query: {
            type: type,
          },
        })
      }
      this.$router.push({
        name: 'userOrder',
        query: {
          tabType: 9999,
        },
      })
    },
    // 支付成功获取现金抵扣券金额信息
    getCouponInfo() {
      this.$store
        .dispatch('getPayOrderAct', {
          payOrderId: this.payOrderId,
        })
        .then(data => {
          MessageBox({
            showCancelButton: true,
            message: data.giftCopy,
            confirmButtonText: '查看',
          }).then(action => {
            if (action == 'confirm') {
              this.$router.push({
                name: 'userCoupon',
              })
            }
          })
        })
    },
    getOrderDetail() {
      let self = this
      return this.$store
        .dispatch('getOrderSimple', {
          payOrderId: this.payOrderId,
        })
        .then(data => {
          let activeUrl = {
            actionType: 27,
            actionData: JSON.stringify({
              businessId: op(data).get('activeInfo.activeCode'),
              childId: op(data).get('activeInfo.groupCode'),
            }),
          }
          self.groupCode = op(data).get('activeInfo.groupCode')
          self.maxDeliveryDate = self.hourToDay(op(data).get('expectDelivery.maxTime'))
          self.productName = op(data).get('skuList.0.productName')
          self.shareData.title = '【' + (priceConversion(op(data).get('skuList.0.price')) || 99) + '元包邮】' + op(data).get('skuList.0.productName')
          self.shareData.imgUrl = addWaterMark(op(data).get('skuList.0.imgUrl'))
          self.orderId = op(data).get('orderId.0')
          self.shareData.link = activeUrl
        })
    },
    getGrouponMembers() {
      let self = this
      return this.$store
        .dispatch('getUUGroupActGroupDetail', {
          groupCode: this.groupCode || '',
        })
        .then(data => {
          let desc = ''
          let attendeeLen = data.users.length
          let maxMember = data.requireUserNumber || ACTIVITY_CONSTANT.ACTIVITY_MAX_GROUP_LENGTH
          if (attendeeLen >= maxMember) {
            self.groupMembers = _.sortBy(data.users, user => {
              return -user.isFounder
            }).slice(0, maxMember)
          } else {
            self.groupMembers = _.sortBy(data.users, user => {
              return -user.isFounder
            }).concat(new Array(maxMember - attendeeLen))
          }
          if (data.needNum === 0) {
            desc = `【${self.productName}】正在发起拼团，快拉好友一起来撸！`
          } else {
            desc = `我正在拼的「${self.productName}」仅剩${data.needNum}个名额，快来加入我的拼单吧`
          }
          self.groupStillNeedNum = data.needNum
          self.groupStatus = data.groupStatus
          self.shareData.desc = desc
          self.groupExpireTime = data.groupExpireTime
          this.groupTimer = setInterval(() => {
            this.now = +moment()
          }, 1000)
        })
    },
    hourToDay(hour) {
      return Math.ceil(hour / 24)
    },
  },
}
</script>
